import { ErrorService } from 'src/services';
import { createReducer } from 'typesafe-actions';
import {
  addEmployeeAsync,
  exportCSVEmployeesAsync,
  getEmployeesAsync,
  getVacantEmployeesAsync,
  setEmployees,
  setOpenEmployeeModal,
  setSelectedEmployee,
  updateEmployeeAsync,
} from './actions';
import { EmployeeInfo, EmployeeModalType } from './types';

/* ------------- Types and Action Creators ------------- */

/* ------------- Initial State ------------- */

export type IEmployeesState = Readonly<{
  employees: Array<EmployeeInfo>;
  selectedEmployee: EmployeeInfo | null;
  totalEmployees: number;
  isLoading: boolean;
  openEmployeeModal: EmployeeModalType;
  isRefresh: boolean;
  error: string | null;
}>;

const initialState: IEmployeesState = {
  employees: [],
  selectedEmployee: null,
  totalEmployees: 0,
  isLoading: false,
  openEmployeeModal: null,
  isRefresh: false,
  error: null,
};

/* ------------- Selectors ------------- */

export default createReducer(initialState)
  /* ------------- employeesAsync ------------- */
  .handleAction(getEmployeesAsync.request, state => ({
    ...state,
    isLoading: true,
  }))
  .handleAction(getEmployeesAsync.success, (state, action) => ({
    ...state,
    isLoading: false,
    employees: action.payload.employees as EmployeeInfo[],
    totalEmployees: action.payload.total,
    isRefresh: false,
    error: null,
  }))
  .handleAction(getEmployeesAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.payload,
  }))
  /* ------------- vacantEmployeesAsync ------------- */
  .handleAction(getVacantEmployeesAsync.request, state => ({
    ...state,
    isLoading: true,
  }))
  .handleAction(getVacantEmployeesAsync.success, (state, action) => ({
    ...state,
    isLoading: false,
    error: null,
  }))
  .handleAction(getVacantEmployeesAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.payload,
  }))

  /* ------------- employeesOptionAsync ------------- */

  /* ------------- employeesUpdateAsync ------------- */
  .handleAction(updateEmployeeAsync.request, state => ({
    ...state,
    isLoading: true,
  }))
  .handleAction(updateEmployeeAsync.success, (state, action) => ({
    ...state,
    isLoading: false,
    openEmployeeModal: 'VIEW',
    isRefresh: true,
    error: null,
  }))
  .handleAction(updateEmployeeAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    error: ErrorService.asyncFailure(action.payload.data),
  }))

  /* ------------- employeesAddAsync ------------- */

  .handleAction(addEmployeeAsync.request, state => ({
    ...state,
    isLoading: true,
  }))
  .handleAction(addEmployeeAsync.success, (state, action) => ({
    ...state,
    isLoading: false,
    openEmployeeModal: false,
    isRefresh: true,
    error: null,
  }))
  .handleAction(addEmployeeAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    error: ErrorService.asyncFailure(action.payload.data),
  }))

  /* ------------- setEmployees ------------- */
  .handleAction(setEmployees, (state, action) => ({
    ...state,
    employees: action.payload,
  }))
  .handleAction(setSelectedEmployee, (state, action) => ({
    ...state,
    selectedEmployee: action.payload,
  }))
  .handleAction(setOpenEmployeeModal, (state, action) => ({
    ...state,
    openEmployeeModal: action.payload,
  }))

  /* ------------- exportCSVTimesheet ------------- */
  .handleAction(exportCSVEmployeesAsync.request, state => ({
    ...state,
    isLoading: true,
  }))
  .handleAction(exportCSVEmployeesAsync.success, (state) => ({
    ...state,
    isLoading: false,
    error: null,
  }))
  .handleAction(exportCSVEmployeesAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    error: ErrorService.asyncFailure(action.payload.data),
  }));
